module.exports = __webpack_public_path__ + "static/media/vip-message-background.b7672227.png";